import { Skeleton } from '@/components/ui/skeleton';
import { A4_PAGE_HEIGHT, A4_PAGE_WIDTH } from '@/constants';

export function ReportPreviewSkeleton() {
    return (
        <div
            className="mx-auto relative flex flex-col gap-8"
            style={{
                width: A4_PAGE_WIDTH,
            }}
        >
            <div
                className="bg-white shadow-xl overflow-visible flex flex-col"
                style={{ height: A4_PAGE_HEIGHT }}
            >
                <div className="p-12 flex-1 overflow-hidden space-y-8">
                    <div className="flex flex-col gap-2">
                        <Skeleton className="h-16 w-32 mb-2" />
                        <Skeleton className="h-8 w-64" />
                        <Skeleton className="h-4 w-48" />
                    </div>

                    <div className="space-y-2">
                        <div className="flex gap-4">
                            <Skeleton className="h-8 flex-1" />
                            <Skeleton className="h-8 flex-1" />
                        </div>
                        <Skeleton className="h-8 w-full" />
                        <Skeleton className="h-8 w-full" />
                    </div>

                    <div className="space-y-6">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="space-y-2">
                                <Skeleton className="h-6 w-1/4 mb-2" />
                                <Skeleton className="h-4 w-full" />
                                <Skeleton className="h-4 w-full" />
                                <Skeleton className="h-4 w-3/4" />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="p-12 pt-0">
                    <div className="flex justify-between items-center border-t border-slate-200 pt-4">
                        <Skeleton className="h-4 w-32" />
                        <Skeleton className="h-4 w-8" />
                    </div>
                </div>
            </div>
        </div>
    );
}
